import { Select } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { CAF_REQUEST_STATUS } from '@/constants/CAFePatronato.constants.js'

import Arrow from '../../svgs/formBuild/ArrowDown.js'

const { Option } = Select

export default function SelectStatus({ onChange }) {
  const { t } = useTranslation()

  return (
    <div>
      <label className='capitalize' htmlFor='status'>
        {t('table.filter.status')}
      </label>
      <Select
        id='status'
        placeholder={t('table.filter.ph.status')}
        suffixIcon={<Arrow style='w-14' />}
        onChange={(val) => onChange(val)}
      >
        <Option value={null}>{t('All')}</Option>
        {CAF_REQUEST_STATUS.map((status) => (
          <Option key={status.value} value={status.value}>
            {t(status.label)}
          </Option>
        ))}
      </Select>
    </div>
  )
}
